import { createFileRoute, redirect } from '@tanstack/react-router';
import { getSelectedSite, getSites } from 'src/api/admin/sites';
export const Route = createFileRoute('/_admin/overview')({
	loader: async () => {
		let selectedSite: { id: string } | null = null;
		try {
			selectedSite = await getSelectedSite();
		} catch {
			// API may fail if no site exists or preferences are invalid
		}
		if (!selectedSite) {
			const sitesRes = await getSites('noPagination=true');
			const sites = sitesRes?.data ?? [];
			if (sites.length > 0) {
				selectedSite = sites[0];
			}
		}
		return { selectedSite };
	},
	component: Overview,
});

function Overview() {
	const { selectedSite } = Route.useLoaderData();
	if (!selectedSite?.id) {
		throw redirect({ to: '/system/sites' });
	}
	throw redirect({
		to: '/$siteId/overview',
		params: { siteId: selectedSite.id },
	});
}
